import iconBoltOutline from 'assets/images/icon-bolt-outline.svg'

import { RuleType } from './types'

interface SegmentFilterIconProps {
  ruleType?: RuleType
}

const SegmentFilterIcon = ({ ruleType: _ruleType }: SegmentFilterIconProps) => {
  return (
    <img
      src={iconBoltOutline}
      alt=""
      className="thanx-ai-segment-visualization__filter-icon"
      width="16"
      height="16"
    />
  )
}

export default SegmentFilterIcon
